<div *ngIf="from === 'materialIngridiant' || from === 'ingredientName'" class="inlineEditingdiv">
  <ng-select
    [clearable]="true"
    [clearOnBackspace]="false"
    container="body"
    id="currentDropdown1"
    [style.padding-bottom.px]="customPaddingBottom"
    [style.width.px]="customWidth"
    class="w-275 drpmaterial crossIconSize personalInputFiled"
    #select
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    bindValue="id"
    [ngModel]="processId == 0 ? null : processId"
    [searchFn]="commonInputSearch"
    [placeholder]="placeHolder"
    groupBy="childItems"
    (change)="updateValue($event)"
    [virtualScroll]="true"
    (click)="focusOn('currentDropdown1')"
    (clear)="onClear($event)"
    [ngClass]="{ 'ingredient-search-input': from === 'ingredientName' }"
  >
    <ng-template ng-header-tmp>
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>
</div>

<div
  *ngIf="from !== 'materialIngridiant'"
  class="inlineEditingdiv"
  [ngClass]="
    from === 'productLoss'
      ? 'checkProductLossNgSelect'
      : from == 'statusColDef' || from == 'verificationStatus'
      ? 'inlineEditingdivStatusWidth'
      : ''
  "
>
  <ng-select
    [clearable]="true"
    id="inline-ng-select"
    [clearOnBackspace]="false"
    container="body"
    class="w-275 crossIconSize"
    [style.padding-bottom.px]="customPaddingBottom"
    [style.width.px]="customWidth"
    *ngIf="
      ['materialIngridiant', 'materialProcess', 'conversionProcess', 'myProject'].includes(from)
    "
    #select
    [ngModel]="processId == 0 ? null : processId"
    [ngClass]="{
      personalInputFiled: ['materialIngridiant', 'materialProcess'].includes(from)
    }"
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    bindValue="id"
    [searchFn]="commonInputSearch"
    [placeholder]="placeHolder"
    groupBy="childItems"
    (change)="updateValue($event)"
    [virtualScroll]="true"
    (click)="focusOn('inline-ng-select')"
    [ngClass]="from === 'materialProcess' ? 'material-process' : ''"
  >
    <ng-template ng-header-tmp>
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>

  <ng-select
    [ngModel]="processId == 0 ? null : processId"
    [bindValue]="bindValue"
    [clearable]="from == 'statusColDef' || from == 'verificationStatus' ? false : true"
    id="currentDropdown2"
    (clear)="onClear($event)"
    [clearOnBackspace]="false"
    class="w-275 custom-ng-text-size crossIconSize"
    [ngClass]="{
      'eol-width': isEOL
    }"
    container="body"
    *ngIf="
      ![
        'materialIngridiant',
        'materialProcess',
        'conversionProcess',
        'myProject',
        'packagingEOL',
        'ingredientName',
        'supplierName',
        'unitName',
        'ingredientCountry',
        'organizationConversionName',
        'organizationMaterialName'
      ].includes(from)
    "
    #select
    [ngClass]="{
      'eol-width': from === 'packagingEOL',
      reuseInlineDropdown: from === 'reuseProcessName'
    }"
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    [searchFn]="commonInputSearchForName"
    [placeholder]="placeHolder"
    style="width: 500px"
    (click)="focusOn('currentDropdown2')"
    (change)="updateValue($event)"
    (clear)="resetTValue(from)"
    [virtualScroll]="true"
    [style.padding-bottom.px]="customPaddingBottom"
  >
    <ng-template
      ng-header-tmp
      *ngIf="from !== 'unitItems' && from !== 'statusColDef' && from !== 'verificationStatus'"
    >
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>
  <div *ngIf="processList$ | async as processList">
    <ng-select
      [ngModel]="processId == 0 ? null : processId"
      [bindValue]="bindValue"
      [clearable]="true"
      id="supplierNameDrp"
      (clear)="onClear($event)"
      [clearOnBackspace]="false"
      class="w-275 custom-ng-text-size crossIconSize"
      container="body"
      *ngIf="from == 'supplierName'"
      #select
      [items]="processList"
      [searchable]="false"
      [bindLabel]="bindLabel"
      [searchFn]="commonInputSearchForName"
      [placeholder]="placeHolder"
      (click)="focusOn('supplierNameDrp')"
      (change)="updateValue($event)"
      (clear)="resetTValue(from)"
      [virtualScroll]="true"
      [style.padding-bottom.px]="customPaddingBottom"
      [ngClass]="{ 'ingredient-search-input': from === 'supplierName' }"
    >
      <ng-template ng-header-tmp>
        <div class="has-feedback">
          <input
            type="text"
            class="form-control accordion-search search-input"
            id="inputValidation"
            (input)="select.filter($any($event.target).value)"
            placeholder="Search..."
          />
          <span class="form-control-feedback">
            <i class="fa fa-search icon"></i>
          </span>
        </div>
      </ng-template>
      <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
        <div
          *ngIf="bindLabel === 'description'"
          title="{{ item?.description }}"
          [ngOptionHighlight]="search"
        >
          {{ item?.description }}
        </div>
        <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
          {{ item.name }}
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        <div
          *ngIf="bindLabel === 'description'"
          title="{{ item?.description }}"
          [ngOptionHighlight]="search"
        >
          {{ item?.description }}
        </div>
        <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
          {{ item.name }}
        </div>
      </ng-template>
    </ng-select>
  </div>
  <ng-select
    [ngModel]="processId == 0 ? null : processId"
    [bindValue]="bindValue"
    [clearable]="true"
    id="unitNameDrp"
    (clear)="onClear($event)"
    [clearOnBackspace]="false"
    class="w-275 custom-ng-text-size crossIconSize"
    container="body"
    *ngIf="from == 'unitName'"
    #select
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    [searchFn]="commonInputSearchForName"
    [placeholder]="placeHolder"
    (click)="focusOn('unitNameDrp')"
    (change)="updateValue($event)"
    (clear)="resetTValue(from)"
    [virtualScroll]="true"
    [style.padding-bottom.px]="customPaddingBottom"
    [ngClass]="{ 'ingredient-search-input': from === 'unitName' }"
  >
    <ng-template ng-header-tmp>
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>
  <ng-select
    [ngModel]="processId == 0 ? null : processId"
    [bindValue]="bindValue"
    [clearable]="true"
    id="ingredientCountryDrp"
    (clear)="onClear($event)"
    [clearOnBackspace]="false"
    class="w-275 custom-ng-text-size crossIconSize"
    container="body"
    *ngIf="from == 'ingredientCountry'"
    #select
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    [searchFn]="commonInputSearchForName"
    [placeholder]="placeHolder"
    (click)="focusOn('ingredientCountryDrp')"
    (change)="updateValue($event)"
    (clear)="resetTValue(from)"
    [virtualScroll]="true"
    [style.padding-bottom.px]="customPaddingBottom"
    [ngClass]="{ 'ingredient-search-input': from === 'ingredientCountry' }"
  >
    <ng-template ng-header-tmp>
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>

  <ng-select
    [ngModel]="processId == 0 ? null : processId"
    bindValue="id"
    [clearable]="true"
    id="currentDropdown3"
    (clear)="onClear($event)"
    [clearOnBackspace]="false"
    class="w-275 custom-ng-text-size crossIconSize"
    [ngClass]="{
      'eol-width': isEOL
    }"
    container="body"
    *ngIf="from === 'packagingEOL'"
    #select
    [ngClass]="from === 'packagingEOL' ? 'eol-width' : ''"
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    [searchFn]="commonInputSearchForName"
    [placeholder]="placeHolder"
    (click)="focusOn('currentDropdown3')"
    (change)="updateValue($event)"
    (clear)="resetTValue(from)"
    [virtualScroll]="true"
    [style.padding-bottom.px]="customPaddingBottom"
  >
    <ng-template ng-header-tmp>
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>
  <ng-select
    [clearable]="true"
    [clearOnBackspace]="false"
    id="organizationMaterialName"
    [style.padding-bottom.px]="customPaddingBottom"
    [style.width.px]="customWidth"
    [dropdownPosition]="dropdownPosition"
    class="w-275 drpmaterial crossIconSize personalInputFiled"
    #select
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    bindValue="id"
    *ngIf="from === 'organizationMaterialName'"
    [ngModel]="processId == 0 ? null : processId"
    [searchFn]="commonInputSearch"
    [placeholder]="placeHolder"
    groupBy="childItems"
    (change)="updateValue($event)"
    [virtualScroll]="true"
    (click)="focusOn('organizationMaterialName')"
    (clear)="onClear($event)"
  >
    <ng-template ng-header-tmp>
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>
  <ng-select
    [clearable]="true"
    [clearOnBackspace]="false"
    id="organizationConversionName"
    [dropdownPosition]="dropdownPosition"
    [style.padding-bottom.px]="customPaddingBottom"
    [style.width.px]="customWidth"
    class="w-275 drpmaterial crossIconSize personalInputFiled"
    #select
    *ngIf="from === 'organizationConversionName'"
    [items]="processList"
    [searchable]="false"
    [bindLabel]="bindLabel"
    bindValue="id"
    [ngModel]="processId == 0 ? null : processId"
    [searchFn]="commonInputSearch"
    [placeholder]="placeHolder"
    groupBy="childItems"
    (change)="updateValue($event)"
    [virtualScroll]="true"
    (click)="focusOn('organizationConversionName')"
    (clear)="onClear($event)"
  >
    <ng-template ng-header-tmp>
      <div class="has-feedback">
        <input
          type="text"
          class="form-control accordion-search search-input"
          id="inputValidation"
          (input)="select.filter($any($event.target).value)"
          placeholder="Search..."
        />
        <span class="form-control-feedback">
          <i class="fa fa-search icon"></i>
        </span>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div
        *ngIf="bindLabel === 'description'"
        title="{{ item?.description }}"
        [ngOptionHighlight]="search"
      >
        {{ item?.description }}
      </div>
      <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
        {{ item.name }}
      </div>
    </ng-template>
  </ng-select>
</div>

<div class="addtooltips align-self-center" class="col-md-4" *ngIf="from === 'materialIngridiant'">
  <ng-template #tipContent>
    <div class="row">
      <span class="selectedMaterialDiv d-flex align-items-start justify-content-start">{{
        materialname
      }}</span>
      <div
        class="col-md-12 d-flex align-items-start justify-content-start pt-2"
        *ngFor="let item of materialInfoData | keyvalue; let i = index"
      >
        <ng-container *ngIf="materialInfoDataKey[i] !== 'name'">
          <span class="col-3 d-flex align-items-start justify-content-start alignData"
            >{{ toTitleCase(materialInfoDataKey[i]) }}
          </span>
          <span class="col-1 d-flex align-items-start justify-content-start alignData">:</span>
          <span
            style="text-align: left !important"
            class="col-8 d-flex align-items-start justify-content-start alignData"
            >{{ materialInfoDataValues[i] }}
          </span>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <div
    placement="auto"
    [ngbTooltip]="tipContent"
    tooltipClass="custom-tooltip"
    container="body"
    data-bs-placement="auto"
    class="materialToolTipIngredient"
  >
    <a><img src="./assets/icons/info-icon.svg" /></a>
  </div>
</div>
